export const KEYS = {
    ENTER: 'Enter',
};
